import { createContext, useContext } from "react"

type ReviewSaveErrorHandler = (
  simulationOutputId: string,
  error: unknown,
) => void

const ReviewSaveErrorContext = createContext<
  ReviewSaveErrorHandler | undefined
>(undefined)

/** Hands failed saves to the review session, which stops editing when another reviewer now holds the conversation. */
export const ReviewSaveErrorProvider = ReviewSaveErrorContext.Provider

export const useReviewSaveErrorHandler = () =>
  useContext(ReviewSaveErrorContext)
